import React, { useState } from "react";
import ReactHtmlParser from "react-html-parser";
import DEFAULT from "../../build/images/default.png";
import { ReactComponent as RepeatRightIcon } from "../../build/images/icons/repeat-right.svg";
import { ReactComponent as RepeatLeftIcon } from "../../build/images/icons/repeat-left.svg";
import { ReactComponent as FavoriteIcon } from "../../build/images/icons/favorite.svg";
import { ReactComponent as FavoriteIconEnable } from "../../build/images/icons/favoritethree.svg";
import { ReactComponent as MoreIcon } from "../../build/images/icons/more-mail.svg";
import CarrousselAttach from "./CarrousselAttach";
import { changeFavoriteMail, registerFavoriteMail } from "../../actions";
import { useDispatch } from "react-redux";
import unicodeToChar from "../../actions/formatUnicode";

let stringAnterior = "";

function highlightSearchInHtml(htmlString, inputSearch) {
  const container = document.createElement("div");
  container.innerHTML = htmlString;

  const textNodes = [];

  function extractTextNodes(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      textNodes.push(node);
    } else {
      for (const childNode of node.childNodes) {
        extractTextNodes(childNode);
      }
    }
  }

  extractTextNodes(container);

  textNodes.forEach((textNode) => {
    const originalText = textNode.nodeValue;
    const regex = new RegExp(`${inputSearch}`, "gi");

    const markedText = originalText.replace(
      regex,
      (match) => `<b class="highlighted yellow">${match}</b>`
    );
    const newNode = document.createElement("span");
    newNode.innerHTML = markedText;

    textNode.replaceWith(newNode);
  });

  return container.innerHTML;
}

const MailContainer = ({ mail, inputSearch, canFavorite = true }) => {
  const dispatch = useDispatch();

  const changeFavorite = (externalcode, id, favorite) => {
    dispatch(changeFavoriteMail(externalcode, favorite));
    dispatch(registerFavoriteMail(id, favorite));
  };

  let text = mail.body_msg;

  if (inputSearch !== "") text = highlightSearchInHtml(text, inputSearch);

  return (
    <div className="attendance__mail-container" id="attendance__mail-container">
      <div
        className="attendance__mail-container__header"
        id={`email-to-${mail.id}`}
      >
        <div className="attendance__mail-container__header-user">
          <div className="attendance__mail-container__header-user__text">
            <span>
              <b>Assunto: {mail.caption}</b>
            </span>
          </div>
        </div>
      </div>
      <hr
        className="attendance__mail-container__divider-subject"
        style={{ opacity: "40%" }}
      ></hr>
      <div className="attendance__mail-container__header">
        <div className="attendance__mail-container__header-user">
          <div className="attendance__mail-container__header-user__photo">
            <img
              src={DEFAULT}
              width="36"
              height="36"
              className="attendance__mail-container__header-user__photo-img"
            />
          </div>
          <div className="attendance__mail-container__header-user__text">
            <span>
              <b>{mail.operator}</b>
            </span>
            {mail.recipients.filter((mail) => mail.type === 0).length !== 0 && (
              <span>
                De:{" "}
                {mail.recipients
                  .filter((mail) => mail.type === 0)
                  .map((email, index) =>
                    index !== 0 ? ", " + email.label : email.label
                  )}
              </span>
            )}
            {mail.recipients.filter((mail) => mail.type === 1).length !== 0 && (
              <span>
                Para:{" "}
                {mail.recipients
                  .filter((mail) => mail.type === 1)
                  .map((email, index) =>
                    index !== 0 ? ", " + email.label : email.label
                  )}
              </span>
            )}
            {mail.recipients.filter((mail) => mail.type === 2).length !== 0 && (
              <span>
                Cc:{" "}
                {mail.recipients
                  .filter((mail) => mail.type === 2)
                  .map((email, index) =>
                    index !== 0 ? ", " + email.label : email.label
                  )}
              </span>
            )}
            {mail.recipients.filter((mail) => mail.type === 3).length !== 0 && (
              <span>
                Cco:{" "}
                {mail.recipients
                  .filter((mail) => mail.type === 3)
                  .map((email, index) =>
                    index !== 0 ? ", " + email.label : email.label
                  )}
              </span>
            )}
          </div>
        </div>
        <div className="attendance__mail-container__header-actions">
          <div className="attendance__mail-container__header-actions__date">
            <span>{mail.date_sending}</span>
            {/* (há 2 dias) */}
          </div>
          <div className="attendance__mail-container__header-actions__icons">
            {canFavorite && (
              <div
                className="attendance__mail-container__header-actions__icons-favorite"
                onClick={() =>
                  changeFavorite(mail.externalcode, mail.id, !mail.favorite)
                }
              >
                {mail.favorite ? <FavoriteIconEnable /> : <FavoriteIcon />}
              </div>
            )}
            {/* <div className="attendance__mail-container__header-actions__icons-reply" onClick={() => handleReplyMail(mail)}>
                      <RepeatLeftIcon />
                    </div> */}
            {/* <div>
                    <RepeatRightIcon />
                    </div> */}
            {/* <div>
                    <MoreIcon />
                    </div> */}
          </div>
        </div>
      </div>
      <div className="attendance__mail-container__body">
        <span>{ReactHtmlParser(text)}</span>
      </div>
      {mail.attachments.length !== 0 && (
        <hr
          className="attendance__mail-container__divider"
          style={{ opacity: "40%" }}
        ></hr>
      )}
      {mail.attachments.map((attach) => (
        <CarrousselAttach attach={attach} />
      ))}
      <hr
        className="attendance__mail-container__divider"
        style={{ opacity: "40%" }}
      ></hr>
    </div>
  );
};

export default MailContainer;
